
namespace Gamification.Gamification {

    export interface ProdottiClassiPickerOptions {
        idProdotto?: number,
        idProdottoClasse?: number,
        hideProdottiClassi?: number[];
    }

    @Serenity.Decorators.registerClass()
    export class ProdottiClassiCheckGrid extends Serenity.EntityGrid<ProdottiClassiRow, ProdottiClassiPickerOptions> {
        protected getColumnsKey() { return ProdottiClassiCheckColumns.columnsKey; }
        protected getDialogType() { return ProdottiClassiDialog; }
        protected getIdProperty() { return ProdottiClassiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiClassiRow.localTextPrefix; }
        protected getService() { return ProdottiClassiService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: ProdottiClassiPickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            return columns;
        }

        protected usePager() {
            return true;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;

            //
            if (this.options.idProdotto && this.options.idProdotto > 0) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.ProdottiClassiRow.Fields.IdProdotto], '=', this.options.idProdotto], request.Criteria);
            }

            //
            if (this.options.idProdottoClasse && this.options.idProdottoClasse > 0) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.ProdottiClassiRow.Fields.IdProdottoClasse], '=', this.options.idProdottoClasse], request.Criteria);
            }

            //
            if (this.options.hideProdottiClassi && this.options.hideProdottiClassi.length) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.ProdottiClassiRow.Fields.IdProdottoClasse], 'not in', [this.options.hideProdottiClassi]], request.Criteria);
            }

            //
            return true;
        }
    }
}